// ==========================================================================
// groots Starter Kit
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================

// Declare global
window.groots = window.groots || {};

// Display debug informations
window.groots.verbose = false;

// Set plugins array
window.groots.plugins = window.groots.plugins || {};

// ==========================================================================
// Polyfills
// ==========================================================================

// Closest
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
                                Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
